import { Download } from "lucide-react";
import React, { useState } from "react";
import { CollapsePanel } from "./CollapsePanel";
import { DetailGrid, DetailGridItem } from "./DetailGrid";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

const getPreviewSrc = (caseId, attachment) => {
  return `/request_attachments/${caseId}/pdf_preview/${attachment.publicId}?attachment_type=${attachment.attachmentType}#toolbar=0`;
};

const AttachmentPreviewModal = ({ caseId, attachment, isOpen, onToggle }) => (
  <Modal isOpen={isOpen} size="lg" toggle={onToggle}>
    <ModalHeader toggle={onToggle}>
      <div className="d-flex align-items-center">
        Attachment Preview
        {attachment && (
          <a className="ms-3 d-inline-block" href={attachment.url} download>
            <Download />
          </a>
        )}
      </div>
    </ModalHeader>
    <ModalBody>
      {attachment && (
        <div className="ratio ratio-letter">
          <iframe src={getPreviewSrc(caseId, attachment)} title={attachment.label} />
        </div>
      )}
    </ModalBody>
  </Modal>
);

export const PriorAuthorizationDetails = ({ priorAuthorizationDetails }) => {
  const faxAttachments = priorAuthorizationDetails?.faxAttachments || [];
  const caseId = priorAuthorizationDetails?.caseId;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewAttachment, setPreviewAttachment] = useState(null);

  const openPreview = (attachment) => {
    setPreviewAttachment(attachment);
    setPreviewOpen(true);
  };

  const togglePreview = () => setPreviewOpen((open) => !open);

  return (
    <CollapsePanel labelText="Submit Right Details">
      <DetailGrid className="detail-grid-large">
        <DetailGridItem title="Phone Number" value={priorAuthorizationDetails?.phoneNumber} />
        <DetailGridItem title="Fax Number" value={priorAuthorizationDetails?.faxNumber} />
        <DetailGridItem
          title="Portal 1"
          value={
            <a href={priorAuthorizationDetails?.portal1Url} target="_blank" rel="noopener noreferrer">
              {priorAuthorizationDetails?.portal1}
            </a>
          }
        />
        <DetailGridItem
          title="Portal 2"
          value={
            <a href={priorAuthorizationDetails?.portal2Url} target="_blank" rel="noopener noreferrer">
              {priorAuthorizationDetails?.portal2}
            </a>
          }
        />
        <DetailGridItem
          title="Portal 3"
          value={
            <a href={priorAuthorizationDetails?.portal3Url} target="_blank" rel="noopener noreferrer">
              {priorAuthorizationDetails?.portal3}
            </a>
          }
        />
        {faxAttachments.length > 0 && (
          <DetailGridItem
            title="Insurance Form"
            value={
              <Button size="sm" color="secondary" outline onClick={() => openPreview(faxAttachments[0])}>
                Fax Form
              </Button>
            }
            hasValue
          />
        )}
      </DetailGrid>
      {faxAttachments.length > 0 && (
        <AttachmentPreviewModal caseId={caseId} attachment={previewAttachment} isOpen={previewOpen} onToggle={togglePreview} />
      )}
    </CollapsePanel>
  );
};
